import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '../../from-input/input.component';
import { requiredTrimmed } from '../../../utils/utils';

@Component({
    selector: 'add-event-manager',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, InputComponent],
    templateUrl: './add-event-manager.component.html',
    styleUrls: ['./add-event-manager.component.scss']
})
export class AddEventManagerComponent implements OnInit, OnDestroy {
    @Input() initialData: any = null;
    @Output() formSubmitted = new EventEmitter<any>();
    @Output() formValidation = new EventEmitter<boolean>();

    form!: FormGroup;
    private dialogConfirmListener?: (event: Event) => void;

    customErrorMessages = {
        firstName: { required: 'Please enter a firstname.' },
        lastName: { required: 'Please enter a lastname.' },
        primaryEmail: { required: 'Please enter a valid primary email.' },
        mobileNumber: {
            required: 'Please enter a phone number.',
            pattern: 'Please enter a valid phone number.'
        },
        secondaryEmail: { required: 'Please enter a valid secondary email.' },
    };

    constructor(private fb: FormBuilder) { }

    ngOnInit(): void {
        this.initForm();
        this.setupDialogListener();
    }

    ngOnDestroy(): void {
        this.cleanupDialogListener();
    }

    private initForm(): void {
        this.form = this.fb.group({
            firstName: [this.initialData?.firstName || '', requiredTrimmed],
            lastName: [this.initialData?.lastName || '', requiredTrimmed],
            secondaryEmail: [this.initialData?.secondaryEmail || '', requiredTrimmed],
            primaryEmail: [this.initialData?.primaryEmail || '', [Validators.required,  Validators.pattern(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    )]],
            mobileNumber: [this.initialData?.mobileNumber || '', ['', [Validators.required, 
                // Validators.pattern(/^(?:\+?61|0)[ ]?[23478](?:[ ]?\d){8}$/)
                    Validators.pattern(/^(?:0[47]\d{8}|\+61 ?[47]\d{8})$/)
                ]]]
        });

        this.formValidation.emit(this.form.valid);
        this.form.valueChanges.subscribe(() => {
            this.formValidation.emit(this.form.valid);
        });
    }

    private setupDialogListener(): void {
        this.dialogConfirmListener = () => this.handleDialogConfirm();
        document.addEventListener('dialogConfirm', this.dialogConfirmListener);
    }

    private cleanupDialogListener(): void {
        if (this.dialogConfirmListener) {
            document.removeEventListener('dialogConfirm', this.dialogConfirmListener);
        }
    }

    handleDialogConfirm(): void {
        if (this.form.valid) {
            this.formSubmitted.emit(this.form.value);
        } else {
            this.markFormAsTouched();
        }
    }

    onSubmit(): void {
        this.handleDialogConfirm();
    }

    private markFormAsTouched(): void {
        this.form.markAllAsTouched();
    }

    isFormValid(): boolean {
        return this.form.valid;
    }
}